import Phaser from 'phaser';
import { TopBar } from './components/TopBar';
import { ControlPanel } from './components/ControlPanel';

export abstract class BaseScene extends Phaser.Scene {
  protected screenWidth = 750;
  protected screenHeight = 1334;

  private readonly sceneName;
  private readonly showLogo;
  private logo;

  protected constructor(sceneName: string, showLogo = false) {
    super(sceneName);
    this.sceneName = sceneName;
    this.showLogo = showLogo;
  }

  create() {
    console.log(`*****${this.sceneName}*****`);

    this.createBackground();

    if (this.showLogo) {
      this.addLogo();
    }

    this.createHeader();
    this.createBody();
    this.createFooter();

    // Change default sound behavior when the scene blur
    this.sound.pauseOnBlur = false;

    this.game.events.on('blur', () => {
      this.sound.mute = true;
    });

    this.game.events.on('focus', () => {
      this.sound.mute = false;
    });
  }

  protected createBackground() {
    const background = this.add.image(this.screenWidth / 2, this.screenHeight / 2, 'background');
    background.setDisplaySize(this.screenWidth, this.screenHeight);
  }

  protected getLogo() {
    return this.logo;
  }

  protected createHeader() {
    new TopBar(this, this.screenWidth);
  }

  protected abstract createBody();

  protected createFooter() {
    new ControlPanel(this, this.screenWidth, this.screenHeight);
  }

  protected pauseTimer() {
    this.tweens.pauseAll();
    this.sound.pauseAll();
    this.time.paused = true;
  }

  protected resumeTimer() {
    this.tweens.resumeAll();
    this.sound.resumeAll();
    this.time.paused = false;
  }

  protected addLogo() {
    this.logo = this.add.image(this.screenWidth / 2 - 10, this.screenHeight / 2 - 180, 'money_roll_logo');
    this.logo.setDisplaySize(410, 150);
  }
}
